import React from 'react';

import { Tag } from '@ekhodealer/ekho-common/rev';

import './ComingSoonOverlay.scss';

interface ComingSoonOverlayProps {
	children: React.ReactNode;
}

export function ComingSoonOverlay({ children }: ComingSoonOverlayProps): React.JSX.Element {
	return (
		<div data-component='coming-soon-overlay'>
			{children}
			<div data-element='overlay'>
				<Tag variant='pill' accent='neutral' size='small' indicator={false}>
					Coming soon
				</Tag>
			</div>
		</div>
	);
}
